import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"0.5\" cy=\"12.5\" r=\"0.5\" transform=\"rotate(180 0.5 12.5)\" fill=\"currentColor\"></circle><circle cx=\"0.5\" cy=\"8.5\" r=\"0.5\" transform=\"rotate(180 0.5 8.5)\" fill=\"currentColor\"></circle><circle cx=\"0.5\" cy=\"4.5\" r=\"0.5\" transform=\"rotate(180 0.5 4.5)\" fill=\"currentColor\"></circle><circle cx=\"0.5\" cy=\"0.5\" r=\"0.5\" transform=\"rotate(180 0.5 0.5)\" fill=\"currentColor\"></circle><path d=\"M2 8.5H12M2 0.5C5.90524 0.5 8.09476 0.5 12 0.5M2 4.5C5.90524 4.5 8.09476 4.5 12 4.5M2 12.5H7\" stroke=\"currentColor\"></path>", 5)
  ])))
}
export default { render: render }